import { Zap } from 'lucide-react'
import { useState } from 'react'
import { useSearchParams } from 'react-router'

import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog'
import { useLeadActionAutomations, useRefetchLeadsOnRunFinish } from '@/models/leadActionAutomation'
import { type SalesLeadFilters } from '@/models/salesLead'
import { LeadActionAutomationCreate } from './LeadActionAutomationCreate'
import { LeadActionAutomationRuns } from './LeadActionAutomationRuns'

interface LeadActionAutomationDialogProps {
  filters: SalesLeadFilters
}

export function LeadActionAutomationDialog({ filters }: LeadActionAutomationDialogProps) {
  const [open, setOpen] = useState(false)
  const [, setSearchParams] = useSearchParams()
  // Mounted while the dialog is closed too, so a run finishing after Run still refreshes the list.
  const { data: runs } = useLeadActionAutomations()
  useRefetchLeadsOnRunFinish(runs)

  function filterByTag(tagId: string) {
    setSearchParams({ tags: tagId })
    setOpen(false)
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" className="text-md">
          <Zap className="mr-2 size-4" />
          Bulk action
        </Button>
      </DialogTrigger>
      <DialogContent size="lg">
        <DialogHeader>
          <DialogTitle>Bulk action</DialogTitle>
        </DialogHeader>
        <LeadActionAutomationCreate filters={filters} onDone={() => setOpen(false)} />
        <LeadActionAutomationRuns onFilterByTag={filterByTag} />
      </DialogContent>
    </Dialog>
  )
}
